import * as mergeWith from 'lodash/mergeWith';
import { environment } from '~env';

function customMerge(objValue: unknown, srcValue: unknown): unknown[] | void {
  if (Array.isArray(objValue) && Array.isArray(srcValue)) {
    return srcValue;
  }
}

function enableEnvConfig(): void {
  try {
    const host = window.location.host;
    const configs: { [key: string]: typeof environment } = (window as any).__spaConfig;
    const config = Object.entries(configs).find(([key]) => {
      const isRegex = key.startsWith('rx:');
      if (isRegex) {
        const rx = new RegExp(key.substring(3));
        return rx.test(host);
      } else {
        return key === host;
      }
    });

    if (config) {
      // tslint:disable-next-line:no-console
      console.log(`[DEV] ENV config "${config[0]}" matched for host "${host}"`);
      mergeWith(environment, config[1], customMerge);
    } else if (configs['default']) {
      // tslint:disable-next-line:no-console
      console.log(`[DEV] No ENV config found, using default`);
      mergeWith(environment, configs['default'], customMerge);
    }
  } catch (error) {
    console.error(error);
  }
}

export function generateRuntimeConfig(): void {
  try {
    if (window.location.host !== 'myrclhome.com') enableEnvConfig();

    const config = JSON.parse(window.sessionStorage.getItem('__spaConfig'));
    if (config) {
      // tslint:disable-next-line:no-console
      console.warn('[DEV] Using local config');
      mergeWith(environment, config, customMerge);
    }
  } catch (error) {
    console.error(error);
  }
}
